import Invoices from "./Container"

export default Invoices
